import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/use-toast";
import { api } from "@/api";
import { useTranslation } from "react-i18next";

const AgencySetPasswordPage = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      toast({
        title: t("agencySetPassword.noToken"),
        variant: "destructive",
      });
    }
  }, [token, t]);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast({ title: t("agencySetPassword.noToken"), variant: "destructive" });
      return;
    }
    if (!password || password !== confirm) {
      toast({ title: t("agencySetPassword.mismatch"), variant: "destructive" });
      return;
    }
    if (password.length < 8) {
      toast({ title: t("agencySetPassword.tooShort"), variant: "destructive" });
      return;
    }
    try {
      setSubmitting(true);
      await api.agencySetPassword({ token, password });
      toast({
        title: t("agencySetPassword.successTitle"),
        description: t("agencySetPassword.successDesc"),
      });
      navigate("/login");
    } catch (e) {
      toast({
        title: t("agencySetPassword.errorTitle"),
        description: e.message,
        variant: "destructive",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{t("agencySetPassword.title")}</CardTitle>
          <CardDescription>{t("agencySetPassword.desc")}</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4" noValidate>
            <div>
              <label className="text-sm font-medium">{t("agencySetPassword.password")}</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-sm font-medium">{t("agencySetPassword.confirm")}</label>
              <Input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="w-full" disabled={submitting}>
              {submitting ? t("agencySetPassword.sending") : t("agencySetPassword.save")}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AgencySetPasswordPage;
